module.exports = __webpack_public_path__ + "img/australia-cancer-male.6e4fd257.png";